import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import {getOrderList} from "../../actions/order"
import MobileView from '../common/mobileView'
import FullPageLoader from '../../components/common/fullPageLoader'

class MyOrders extends Component {


    componentDidMount() {
        const { connection_id, userDetails,tenant_name } = this.props
        this.props.getOrderList(connection_id, userDetails.COM_CONSUMER_MOBILE_NO,tenant_name)
    }

    handleRemoveCartItem(event,item){
        event.preventDefault();
        const options = {
            connection_id: this.props.connection_id,
            web_session_trans_id: this.props.web_session_trans_id,
            booking_store_id: this.props.booking_store_id,
            lot_code: item.RID_LOT_CD,
        }
        // 
        this.props.removeFromCart(options);
        
    }

    render() {

        const { orderItems, symbol, loading } = this.props;

        if (loading) return <div><FullPageLoader /></div>
        return (
            <div>
                {/*SEO Support*/}
                <Helmet>
                <title>{this.props.customer_name} | My Orders</title>
                </Helmet>
                {/*SEO Support End */}

                {orderItems.length > 0 ?
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                <div className="mini-title">
                                        <span>My Orders</span>
                                    </div>
                                    <div className="mini-title-divider"></div>
                                     {/* Mobile Titlw Section */}
                                     <div className="mobile-title">
                                        <span>My Order</span>
                                    </div>
                                    <div className="mobile-divider"></div>
                                    {/* Mobile Titlw Section Ends*/}
                                    <div class="table-responsive">
                                    <table className="table cart-table table-responsive-xs">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col">image</th>
                                                <th scope="col">product name</th>
                                                <th scope="col">price</th>
                                                <th scope="col">quantity</th>
                                                <th scope="col">order No</th>
                                                <th scope="col">order date</th>
                                                <th scope="col">Status</th>
                                            </tr>
                                        </thead>
                                        {orderItems.sort((a,b) => new Date(b.RIH_CART_CREATE_DATE) - new Date(a.RIH_CART_CREATE_DATE)).map((item, index) => {
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        <td>
                                                            <Link to={`${process.env.PUBLIC_URL}/PD/${item.RPD_LOT_CD}`}>
                                                                <img src={item.SKU_IMAGE} alt={item.SKU_IMAGE} />
                                                            </Link>
                                                        </td>
                                                        <td><Link to={`${process.env.PUBLIC_URL}/PD/${item.RPD_LOT_CD}`} className="no-display-pls">{item.SKU_DESC}</Link>
                                                            {/* <div className="mobile-cart-content row"> */}
                                                                {/* <div className="col-xs-12"> */}
                                                                    {/* <div className="qty-box"> */}
                                                                        {/* <div className="input-group"> */}
                                                                            {/* <input type="text" name="quantity"
                                                                                className="form-control input-number" defaultValue={item.RPD_ORDER_QTY} /> */}
                                                                                {/* {item.RPD_ORDER_QTY} */}
                                                                        {/* </div> */}
                                                                    {/* </div> */}
                                                                {/* </div> */}
                                                                
                                                                {/* <div className="col-xs-12">
                                                                    <h4>{item.RPD_ORDER_QTY} QTY</h4>
                                                                    <h4>{symbol}{item.RID_PRICE}</h4>
                                                                    <h6>{item.RPD_PRINCIPAL_ORDER_NO}</h6>
                                                                    <h6>{item.RIH_CART_CREATE_DATE}</h6>
                                                                    <h6>Status - {item.RPD_ITEM_STATUS_DESC}</h6>
                                                                </div> */}
                                                                {/* <div className="col-xs-3">
                                                                    <h2 className="td-color">
                                                                        <a href="#" className="icon" onClick={(event) => this.handleRemoveCartItem(event,item)}>
                                                                            <i className="icon-close"></i>
                                                                        </a>
                                                                    </h2>
                                                                </div> */}
                                                            {/* </div> */}
                                                            <MobileView 
                                                            view={'order'}
                                                            data={item}
                                                            functions={{}}
                                                            />
                                                        </td>
                                                        <td className="no-display-pls"><h6>{symbol}{item.RID_ITEM_PRICE}</h6></td>
                                                        {/* <td> */}
                                                            {/* <div className="qty-box"> */}
                                                                {/* <div className="input-group"> */}
                                                                    {/* <span className="input-group-prepend">
                                                                        <button type="button" className="btn quantity-left-minus" onClick={() => this.props.decrementQty(item.id)} data-type="minus" data-field="">
                                                                            <i className="fa fa-angle-left"></i>
                                                                        </button>
                                                                    </span> */}
                                                                    {/* <input type="text" name="quantity" value={parseInt(item.RPD_ORDER_QTY)} readOnly={true} className="form-control input-number" /> */}
                                                                    <td className="no-display-pls"><h6>{item.RPD_ORDER_QTY}</h6></td>
                                                                    {/* <span className="input-group-prepend">
                                                                        <button className="btn quantity-right-plus" onClick={() => this.props.incrementQty(item, 1)} data-type="plus" disabled={(item.qty >= item.stock) ? true : false}>
                                                                            <i className="fa fa-angle-right"></i>
                                                                        </button>
                                                                    </span> */}
                                                                {/* </div> */}
                                                            {/* </div> */}
                                                        {/* </td> */}
                                                        <td className="no-display-pls"><h6>{item.RPD_PRINCIPAL_ORDER_NO}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RIH_CART_CREATE_DATE}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RPD_ITEM_STATUS_DESC}</h6></td>
                                                    </tr>
                                                </tbody>)
                                        })}
                                    </table></div>
                                    {/* <table className="table cart-table table-responsive-md">
                                        <tfoot>
                                            <tr>
                                                <td>total price :</td>
                                                <td><h2>{symbol} {total} </h2></td>
                                            </tr>
                                        </tfoot>
                                    </table> */}
                                </div>
                            </div>
                            <div className="row cart-buttons">
                                <div className="col-12">
                                    {/* <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping</Link> */}
                                    <button className="btn btn-solid" onClick={() => this.props.history.goBack()}>continue shopping</button>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div >
                                        <div className="col-sm-12 empty-cart-cls text-center">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/icon-empty-cart.png`} className="img-fluid mb-4" alt="" />
                                            <h5>
                                                <strong>You do not have any Orders to view.</strong>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    loading: state.orders.loading,
    orderItems: state.orders.orderList,
    userDetails: state.user.user_details,
    symbol: state.data.symbol,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    tenant_name:state.tenant.store_details && state.tenant.store_details.tenant_name
})

export default connect(
    mapStateToProps,
    { getOrderList }
)(withRouter(MyOrders))